import api from "../../../shared/services/api";

export async function fetchFilterOptions(startDate, endDate, filters = {}) {
    const response = await api.post("/tracking-relatorio-v2/filter-options", {
        start: startDate, end: endDate,
        ...filters,
    });
    return response.data;
}

export async function fetchFunil(startDate, endDate, filters = {}) {
    const response = await api.post("/tracking-relatorio-v2/funil", {
        start: startDate, end: endDate,
        ...filters,
    });
    return response.data;
}

export async function fetchLeads(startDate, endDate, filters = {}) {
    const response = await api.post("/tracking-relatorio-v2/leads", {
        start: startDate, end: endDate,
        ...filters,
    });
    return response.data;
}

export async function fetchVideos(startDate, endDate, filters = {}) {
    const response = await api.post("/tracking-relatorio-v2/videos", { start: startDate, end: endDate, ...filters });
    return response.data;
}

export async function fetchVideoCompradores(startDate, endDate, videoKey, filters = {}) {
    const response = await api.post("/tracking-relatorio-v2/video-compradores", { start: startDate, end: endDate, videoKey, ...filters });
    return response.data;
}

// Espectadores de um vídeo (id do vídeo), com lead vinculado quando existe
export async function fetchVideoEspectadores(startDate, endDate, videoKey, filters = {}) {
    const response = await api.post("/tracking-relatorio-v2/video-espectadores", { start: startDate, end: endDate, videoKey, ...filters });
    return response.data;
}

// Compras do produto no período (principais + orderbumps), com visitor_id pra abrir a jornada
export async function fetchCompras(startDate, endDate, filters = {}) {
    const response = await api.post("/tracking-relatorio-v2/compras", { start: startDate, end: endDate, ...filters });
    return response.data;
}

export async function fetchJornada(visitorId) {
    const response = await api.get(`/tracking-relatorio-v2/jornada/${visitorId}`);
    return response.data;
}

export async function fetchVendasSemTracking(startDate, endDate, produtoId) {
    const params = {};
    if (startDate) params.start = startDate;
    if (endDate) params.end = endDate;
    if (produtoId) params.produto_id = produtoId;
    const response = await api.get("/tracking-relatorio-v2/vendas-sem-tracking", { params });
    return response.data;
}

export async function fetchVisitantes(startDate, endDate, filtroCompra = 'todos', filters = {}, page = 1, pageSize = 50) {
    const response = await api.post("/tracking-relatorio-v2/visitantes", {
        start: startDate, end: endDate, filtroCompra, page, pageSize,
        ...filters,
    });
    return response.data;
}

export async function fetchTrackingConfig() {
    const response = await api.get("/tracking-admin/config");
    return response.data;
}

export async function saveTrackingConfig(data) {
    const response = await api.put("/tracking-admin/config", data);
    return response.data;
}

export async function adicionarDominioTracking(host) {
    const response = await api.post("/tracking-admin/dominio-tracking", { host });
    return response.data;
}

export async function removerDominioTracking(host) {
    const response = await api.delete(`/tracking-admin/dominio-tracking/${encodeURIComponent(host)}`);
    return response.data;
}

export async function verificarDominioTracking(host) {
    const response = await api.post(`/tracking-admin/dominio-tracking/${encodeURIComponent(host)}/verificar`);
    return response.data;
}

export async function validarPixel({ pixel_row_id, pixel_id, access_token, test_event_code }) {
    const response = await api.post("/tracking-admin/validar-pixel", { pixel_row_id, pixel_id, access_token, test_event_code });
    return response.data;
}

export async function sendTestEvent(pixel_row_id, event_name) {
    const response = await api.post("/tracking-admin/test-event", { pixel_row_id, event_name });
    return response.data;
}

export async function fetchSnippetProduto(produto_id) {
    const response = await api.get("/tracking-admin/script", { params: { produto: produto_id } });
    return response.data;
}

export async function adicionarPixel(produto_id, dados) {
    const response = await api.post(`/tracking-admin/produtos/${produto_id}/pixels`, dados);
    return response.data;
}

export async function editarPixel(pixel_row_id, dados) {
    const response = await api.put(`/tracking-admin/pixels/${pixel_row_id}`, dados);
    return response.data;
}

export async function removerPixel(pixel_row_id) {
    const response = await api.delete(`/tracking-admin/pixels/${pixel_row_id}`);
    return response.data;
}

export async function copiarPixels(produto_id, modo, produtos) {
    const response = await api.post(`/tracking-admin/produtos/${produto_id}/pixels/copiar`, { modo, produtos });
    return response.data;
}

export async function fetchPaginasProduto(produto_id, dias = 30) {
    const response = await api.get(`/tracking-admin/produtos/${produto_id}/paginas`, { params: { dias } });
    return response.data;
}

export async function adicionarPaginaProduto(produto_id, url) {
    const response = await api.post(`/tracking-admin/produtos/${produto_id}/paginas`, { url });
    return response.data;
}

export async function removerPaginaProduto(pagina_id) {
    const response = await api.delete(`/tracking-admin/paginas/${pagina_id}`);
    return response.data;
}

export async function fetchPaginasSemProduto(dias = 7) {
    const response = await api.get("/tracking-admin/paginas-sem-produto", { params: { dias } });
    return response.data;
}

export async function adicionarContaMeta(produto_id, ad_account_id, nome) {
    const response = await api.post(`/tracking-admin/produtos/${produto_id}/contas-meta`, { ad_account_id, nome });
    return response.data;
}

export async function removerContaMeta(conta_id) {
    const response = await api.delete(`/tracking-admin/contas-meta/${conta_id}`);
    return response.data;
}
